<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Detalhar Cliente</h4>
			<form>
				<div class="formgroup" *ngIf="isExibirSpinnerPrincipal()">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
					</div>
					<div class="flex justify-content-center">
						<p-progressSpinner></p-progressSpinner>
					</div>
				</div>
				<div class="formgroup" *ngIf="cliente && !isExibirSpinnerPrincipal()">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="col-12 md:col-12">
								<h5>Dados Pessoais</h5>
						</div>
						<div class="form-group field col-12 md:col-1">
							<label>Código</label>
							<label class="form-control" id="id">{{ cliente.id }}</label>
						</div>

						<div class="form-group field col-12 md:col-4">
							<label>Nome</label>
							<label class="form-control" id="nome">{{ cliente.nome }}</label>
						</div>

						<div class="form-group field col-12 md:col-2">
							<label>Apelido</label>
							<label class="form-control" id="email">{{ cliente.apelido }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>CPF</label>
							<label class="form-control" id="email">{{ cliente.cpf| cpfPipe }}</label>
						</div>

						<div class="form-group field col-12 md:col-2">
							<label>Aniversário</label>
							<label class="form-control" id="aniversario">{{ cliente.aniversario | date: 'dd/MM'}}</label>
						</div>
						
						<div class="form-group field col-12 md:col-4">
							<label>E-mail</label>
							<label class="form-control" id="email">{{ cliente.email }}</label>
						</div>

						<div class="col-12 md:col-12">
							<h5>Endereço</h5>
						</div>

						<div class="form-group field col-12 md:col-2">
							<label>CEP</label>
							<label class="form-control" id="email">{{ cliente.cep }}</label>
						</div>

						<div class="form-group field col-12 md:col-5">
							<label>Logradouro</label>
							<label class="form-control" id="logradouro">{{ cliente.logradouro }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Bairro</label>
							<label class="form-control" id="bairro">{{ cliente.bairro }}</label>
						</div>

						<div class="form-group field col-12 md:col-2">
							<label>Número</label>
							<label class="form-control" id="numeroEndereco">{{ cliente.numeroEndereco}}</label>
						</div>
						
						<div class="form-group field col-12 md:col-3">
							<label>Complemento</label>
							<label class="form-control" id="complementoEndereco">{{ cliente.complementoEndereco }}</label>
						</div>
						<div class="form-group field col-12 md:col-1">
							<label>Estado</label>
							<label class="form-control" id="uf">{{ cliente.uf}}</label>
						</div>
						
						<div class="form-group field col-12 md:col-4">
							<label>Cidade</label>
							<label class="form-control" id="cidade">{{ cliente.cidade }}</label>
						</div>

						<div class="col-12 md:col-12">
						</div>

						

						<div class="col-12 md:col-12">
							<h5>Contatos</h5>
						</div>

						<div class="field col-12 md:col-12" *ngIf="listaContatos.length === 0">
							<label >Nenhum contato cadastrado</label>
						</div>

						<div class="field col-12 md:col-12" *ngIf="listaContatos.length > 0">
							<p-table #dt1 [value]="listaContatos" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" 
								responsiveLayout="scroll" styleClass=" p-datatable-sm">
								
								<ng-template pTemplate="header">
									<tr>
										<th>
											<div class="flex justify-content-between align-items-center">
												Número
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Identificador
											</div>
										</th>
										

										<th>
											<div class="flex justify-content-between align-items-center">
												Principal
											</div>
										</th>
										
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.numero}}
										</td>
										<td>
											<label>{{item.identificacao ? item.identificacao : 'Não informado'}}</label>
										</td>
										
										<td>
											<label>{{item.principal ? 'Sim' : 'Não'}}</label>
										</td>
										

									</tr>
								</ng-template>
							</p-table>
						</div>

						<div class="col-12 md:col-12">
							<h5>Dados adicionais</h5>
						</div>

						<div class="form-group field col-12 md:col-2">
							<label>Indicador</label>
							<label class="form-control" id="indicador">{{ cliente.indicadorCliente }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Última comanda</label>
							<label class="form-control" id="ultimaComanda">{{ cliente.ultimaComanda | date: 'dd/MM/yyyy hh:mm' }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Cadastro</label>
							<label class="form-control" id="dataCriacao">{{ cliente.dataCriacao | date: 'dd/MM/yyyy hh:mm' }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Última atualização</label>
							<label class="form-control" id="dataAtualizacao">{{ cliente.dataAtualizacao | date: 'dd/MM/yyyy hh:mm' }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Saldo</label>
							<label class="form-control" id="saldoConta">R$ {{ cliente.saldoConta }}</label>
						</div>

						<div class="form-group field col-12 md:col-2">
							<label>Situação</label>
							<div class="form-control">
								<label class="product-badge status-instock" id="status" *ngIf="cliente.status">ATIVO</label>
								<label class="product-badge status-outofstock" id="status" *ngIf="!cliente.status">INATIVO</label>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>